import { call, put, takeEvery } from 'redux-saga/effects';
import { searchBikeModel } from '../../requests/search_bikes_by_params';
import { searchBikeModelsSuccess, searchBikeModelsFailure } from '../actions/search_bikes.actions';
import { SEARCH_BIKE_MODELS_REQUEST } from '../constants/search_bikes.constants';

function* searchBikeModelsRequest({ searchText, brand_id }) {
    const response = yield call(searchBikeModel, searchText, brand_id);

    if (response.result) {
        yield put(searchBikeModelsSuccess(response.options));
    } else {
        yield put(searchBikeModelsFailure(response.error));
    }
}

export default function* searchBikeModelsSaga() {
    yield takeEvery(SEARCH_BIKE_MODELS_REQUEST, searchBikeModelsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_bike_models.saga.js